<template>
  <div>
    <section class="pb-2">
      <b-col class="d-flex justify-content-between px-0 pt-25">
        <b-button
          v-b-modal.modal-create-section-info
          variant="primary"
          :disabled="isLoading"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Admin.Info.AddSectionInfo') }}
        </b-button>
        <SearchInputField
          :disabled="isLoading"
          :placeholder="$tk('Admin.Accounts.Search')"
          @onInputSearch="onSearchChange"
        />
      </b-col>
      <b-card
        class="my-50"
        no-body
      >
        <Table
          :data="sectionGroup"
          :columns="sectionGroupColumns"
          :is-loading="isLoading"
          type-of-table="SectionGroup"
          :enable-pagination="false"
        />

        <b-modal
          id="modal-create-section-info"
          :ok-title="$tk('ClientPortal.Form.Actions.Add')"
          :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
          centered
          cancel-variant="outline-secondary"
          size="md"
          :title="$tk('ClientPortal.Admin.Info.NewSectionInfo')"
          no-enforce-focus
          :ok-disabled="saving || isFormComplete()"
          @change="getSectionGroups"
          @ok="save"
        >
          <b-form-group
            :label="$tk('ClientPortal.Form.Name')"
            label-size="xs"
            :invalid-feedback="errors['Name']"
          >
            <b-form-input
              v-model="sectionInfoModel.name"
              size="sm"
              type="text"
              :placeholder="$tk('ClientPortal.Form.NamePlaceholder')"
              :state="errors['Name'] == null ? null : false"
            />
          </b-form-group>
        </b-modal>
      </b-card>
    </section>
  </div>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Table from '@/components/Table.vue'
import SearchInputField from '@/components/SearchInputField.vue'
import notification from '@/mixins/toastification'
import InfoService from '@/api/admin/info.service'
import translation from '@/mixins/translate'
import store from '@/store'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    SearchInputField,
    GjIcon,
    Table,
  },
  mixins: [notification],
  setup(_, context) {
    const sectionGroupColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Id'),
        field: 'id',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Name'),
        field: 'name',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Active'),
        field: 'active',
      },
    ]
    const isLoading = ref(false)
    const sectionGroup = computed(() => store.getters.getSectionGroup)
    const errors = ref({})
    const sectionInfoModel = ref({})
    const saving = ref(false)
    const { id } = context.root.$route.params

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getSectionGroup', id)
      sectionGroup.value.searchTerm = ''
      isLoading.value = false
    })

    const getSectionGroups = async () => {
      sectionInfoModel.value = {}
      await store.dispatch('getSectionGroup', id)
    }

    const isFormComplete = () => {
      const { name } = sectionInfoModel.value
      return !(name)
    }

    const save = async bvModalEvt => {
      bvModalEvt.preventDefault()
      saving.value = true
      sectionInfoModel.value.groupId = id
      sectionInfoModel.value.htmlContent = sectionInfoModel.value.name
      try {
        const response = await InfoService.createSection(sectionInfoModel.value)
        if (response.saved) {
          bvModalEvt.vueTarget.hide('modal-create-section-info')
          response.message
            ? notification.methods.success(response.message)
            : notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(response.message)
          errors.value = response.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        saving.value = false
        await store.dispatch('getSectionGroup', id)
      }
    }

    const onSearchChange = async value => {
      sectionGroup.value.searchTerm = value
    }

    return {
      isLoading,
      sectionGroup,
      errors,
      sectionInfoModel,
      saving,
      getSectionGroups,
      save,
      isFormComplete,
      onSearchChange,
      sectionGroupColumns,
    }
  },
}
</script>
